import { useState } from "react";
import { HelpCircle, X, Sparkles } from "lucide-react";

export function TutorialHint({ id, title, steps }) {
  const [open, setOpen] = useState(() => !localStorage.getItem(`tuto_${id}`));

  if (!open) {
    return (
      <button
        data-testid={`tutorial-open-${id}`}
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 text-xs text-cyan-400/80 hover:text-cyan-300 transition-colors"
      >
        <HelpCircle size={14} /> Tutorial rápido
      </button>
    );
  }

  return (
    <div data-testid={`tutorial-${id}`} className="glass rounded-2xl p-5 border-l-2 border-l-cyan-400 anim-fade-up">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-2 mb-3">
          <Sparkles size={16} className="text-cyan-400" />
          <h4 className="font-display text-sm font-semibold text-white">{title}</h4>
        </div>
        <button data-testid={`tutorial-close-${id}`} onClick={() => setOpen(false)} className="text-slate-500 hover:text-white transition-colors">
          <X size={16} />
        </button>
      </div>
      <ol className="space-y-2">
        {steps.map((s, i) => (
          <li key={i} className="flex gap-3 text-sm text-slate-300">
            <span className="shrink-0 w-5 h-5 rounded-full bg-cyan-400/15 border border-cyan-400/30 text-cyan-300 text-[10px] font-mono2 flex items-center justify-center">{i + 1}</span>
            <span className="min-w-0 break-words">{s}</span>
          </li>
        ))}
      </ol>
      <button
        data-testid={`tutorial-dismiss-${id}`}
        onClick={() => { localStorage.setItem(`tuto_${id}`, "1"); setOpen(false); }}
        className="mt-4 text-xs font-semibold text-[#04121a] btn-neon px-3 py-1.5 rounded-lg"
      >
        Entendi, não mostrar de novo
      </button>
    </div>
  );
}
